import React, { useState } from "react";
import styles from "./Modal.module.css";
import upgradeImage from "./img/upload.png";
import closeImage from "./img/close.png";
import compareImage from "./img/HighRes-Pixelated.svg"
import StacInterface from "utils/StacInterface";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { CircularProgress } from "@mui/material";

const templates = {
    starter: {
        title: 'UPGRADE TO STARTER',
        message: 'See clearly and gain confidence.',
        paragraph: 'Upgrade to a Starter plan to unlock full resolution, manage users and more.',
        bullets: [
            'View full resolution images',
            'Export imagery for offline use',
            'Compare image dates '
        ],
        image: compareImage,
        plan: 'starter'
    },
    professional: {
        title: 'UPGRADE TO PROFESSIONAL',
        message: 'Access using Web Map Services.',
        paragraph: 'Upgrade plan Professional or Enterprise authenticate Web Map Services.',
        bullets: [
            'Stream WMS, WMTS & WMS services',
            'Integrate with desktop applications',
            'Build custom map services'
        ],
        image: compareImage,
        plan: 'professional'
    },
    enterprise: {
        title: 'UPGRADE TO ENTERPRISE',
        message: 'Upgrade to unlock full resolution.',
        paragraph: 'Upgrade plan Starter or greater to view full resolution and export data.',
        bullets: [
            'Stream WMS, WMTS & WMS services',
            'Integrate with desktop applications',
            'Build custom map services'
        ],
        image: compareImage,
        plan: 'enterprise'
    }
}

const UpgradeModal = ({ setIsOpen, templateName, callOnClose }) => {
    const [firstButtonLoadingIcon, setFirstButtonLoadingIcon] = useState(false);
    const [secondButtonLoadingIcon, setSecondButtonLoadingIcon] = useState(false);

    const close = () => {
        setIsOpen(false);
        callOnClose();
    }

    const getPaymentPage = (plan, planInterval) => {
        StacInterface.instance.getUpgradePlanPaymentPage(plan, planInterval).then((response) => {
            window.open(response.data, '_blank');
            setFirstButtonLoadingIcon(false);
            setSecondButtonLoadingIcon(false);
        }).catch(() => {
            withReactContent(Swal).fire({
                title: 'Error',
                html: 'Cannot redirect to the payment page.',
            });
            setFirstButtonLoadingIcon(false);
            setSecondButtonLoadingIcon(false);
        })
    }

    const template = templates[templateName]
    if (template === undefined){
        withReactContent(Swal).fire({
            title: 'Error',
            html: 'Upgrade modal template doesnt exist.',
        });
        return null;
    }

    return (
        <>
            <div className={styles.darkBG} onClick={() => close()} />
            <div className={styles.centered}>
                <div className={styles.modal}>
                    <button className={styles.closeBtn} onClick={() => close()}>
                        <img src={closeImage} alt="close" />
                    </button>
                    <div className={styles.modalContent}>
                        <div className={styles.row}>
                            <div className={styles.left}>
                                <div className={styles.modalHeader}>
                                    <div className={styles.uploadContainer}>
                                        <img className={styles.uploadIcon} alt="Upgrade" src={upgradeImage} />
                                    </div>
                                    <div>
                                        <h5 className={styles.heading}>{template.title}</h5>
                                    </div>
                                </div>
                                <h1 className={styles.h1}>{template.message}</h1>
                                <h2 className={styles.h2}>
                                    {template.paragraph}
                                </h2>
                                <p className={styles.p}>
                                    <span>&#8226; </span>{template.bullets[0]}<br />
                                    <span>&#8226; </span>{template.bullets[1]}<br />
                                    <span>&#8226; </span>{template.bullets[2]} 
                                </p>
                                <div className={styles.modalActions}>
                                    {template.plan !== 'enterprise' ? 
                                        <>
                                            <button className={styles.upgradeButton + ' ' + styles.yearlyUpgradeButton} onClick={() => {
                                                setFirstButtonLoadingIcon(true);
                                                getPaymentPage(template.plan, 'year');
                                            }}>
                                                <div style={{position: 'relative'}}>
                                                    {firstButtonLoadingIcon && <CircularProgress size={20} className={styles.loadingIcon} color="inherit"/>}
                                                    Pay Yearly -  3 months free
                                                </div>
                                            </button>
                                            <button className={styles.upgradeButton + ' ' + styles.monthlyUpgradeButton} onClick={() => {
                                                setSecondButtonLoadingIcon(true);
                                                getPaymentPage(template.plan, 'month')
                                            }}>
                                                <div style={{position: 'relative'}}>
                                                    {secondButtonLoadingIcon && <CircularProgress size={20} className={styles.loadingIcon}/>}
                                                    Pay Monthly - cancel anytime
                                                </div>
                                            </button>
                                        </>
                                    :
                                        <>
                                            <a href="https://www.fastmap.ai/contact-sales" target="_blank" rel="noreferrer">
                                                <button className={styles.upgradeButton + ' ' + styles.yearlyUpgradeButton} onClick={() => close()}>
                                                    Contact Sales
                                                </button>
                                            </a>
                                            <a href="https://www.fastmap.ai/book-a-demo" target="_blank" rel="noreferrer">
                                                <button className={styles.upgradeButton + ' ' + styles.monthlyUpgradeButton} onClick={() => close()}>
                                                    Book a Demo
                                                </button>
                                            </a>
                                        </>
                                    }
                                </div>
                            </div>
                            <div className={styles.right}>
                                <img src={template.image} alt="Compare Tool"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UpgradeModal;